import React from "react";
import { Checkbox, Segmented, Select } from "antd";
import ContentBlock from "../../../../components/Layout/ContentBlock";
import TabUi from "../TabUi";
import TableFilterBox from "../../../../components/common/TableFilterBox";
import { SelectInput, TextInput } from "../../../../components/globals";
import { antdAsyncMessageSuccess } from "../../../../helpers/AsyncMessage";

const MOCK_QUEUE = [
  {
    id: "q1",
    incoming: "SAMSUNG ELECTRONICS LT",
    supplier: "Elko",
    suggestion: "samsung",
    products: [
      { sku: "BB-1048221", name: 'Samsung QE55S90D 55" OLED TV' },
      { sku: "BB-1048222", name: 'Samsung QE65S90D 65" OLED TV' },
      { sku: "BB-1048310", name: "Samsung HW-Q700D soundbar" },
      { sku: "BB-1048415", name: 'Samsung UE43CU7172 43" LED TV' },
    ],
  },
  {
    id: "q2",
    incoming: "Philips / Signify",
    supplier: "Nordis",
    suggestion: "",
    products: [
      { sku: "BB-2210044", name: "Philips Hue White E27 1100lm" },
      { sku: "BB-2210045", name: "Philips Hue Bridge v2" },
      { sku: "BB-2210120", name: "Philips Series 5000 elektrinis skustuvas" },
    ],
  },
  {
    id: "q3",
    incoming: "LOREAL GROUP",
    supplier: "ACME Baltic",
    suggestion: "",
    products: [
      { sku: "BB-3390812", name: "L'Oréal Paris Revitalift serumas 30ml" },
      { sku: "BB-3390813", name: "L'Oréal Paris Elseve šampūnas 400ml" },
      { sku: "BB-3390820", name: "L'Oréal Professionnel Metal Detox 250ml" },
      { sku: "BB-3390901", name: "Garnier Skin Naturals micelinis vanduo" },
      { sku: "BB-3390902", name: "Maybelline Sky High blakstienų tušas" },
    ],
  },
  {
    id: "q4",
    incoming: "XIAOMI TECH",
    supplier: "Elko",
    suggestion: "xiaomi",
    products: [
      { sku: "BB-4471200", name: "Xiaomi Redmi Note 13 Pro 256GB" },
      { sku: "BB-4471201", name: "Xiaomi Smart Band 9" },
      { sku: "BB-4471244", name: "Xiaomi Robot Vacuum S20+" },
      { sku: "BB-4471250", name: 'Xiaomi TV A Pro 55"' },
      { sku: "BB-4471266", name: "Xiaomi Electric Scooter 4 Lite" },
      { sku: "BB-4471290", name: "Xiaomi Smart Air Purifier 4 Lite" },
    ],
  },
  {
    id: "q5",
    incoming: "BOSCH HAUSGERÄTE",
    supplier: "Nordis",
    suggestion: "bosch",
    products: [
      { sku: "BB-5512003", name: "Bosch Serie 6 WGG24400SN skalbyklė" },
      { sku: "BB-5512040", name: "Bosch MUM58L20 virtuvinis kombainas" },
    ],
  },
];

const MOCK_BRANDS = [
  { code: "samsung", name: "Samsung", products: 1284, aliases: ["SAMSUNG ELECTRONICS", "Samsung Baltics"] },
  { code: "philips", name: "Philips", products: 642, aliases: ["PHILIPS CONSUMER", "Philips Lighting"] },
  { code: "loreal_paris", name: "L'Oréal Paris", products: 318, aliases: ["L'OREAL PARIS"] },
  { code: "loreal_professionnel", name: "L'Oréal Professionnel", products: 96, aliases: [] },
  { code: "garnier", name: "Garnier", products: 143, aliases: ["GARNIER LT"] },
  { code: "maybelline", name: "Maybelline New York", products: 121, aliases: [] },
  { code: "xiaomi", name: "Xiaomi", products: 877, aliases: ["XIAOMI GLOBAL", "Mi Store"] },
  { code: "bosch", name: "Bosch", products: 511, aliases: ["BSH Hausgeräte"] },
  { code: "sony", name: "Sony", products: 466, aliases: [] },
  { code: "lg", name: "LG Electronics", products: 703, aliases: ["LG ELECTRONICS LT"] },
];

const SUPPLIER_OPTIONS = [
  { label: "All", value: "" },
  { label: "Elko", value: "Elko" },
  { label: "ACME Baltic", value: "ACME Baltic" },
  { label: "Nordis", value: "Nordis" },
];

const STATUS_OPTIONS = [
  { label: "Unmapped", value: "unmapped" },
  { label: "Mapped", value: "mapped" },
  { label: "All", value: "" },
];

const VISIBLE_SKUS = 3;

const EMPTY_FILTERS = { incoming: "", sku: "", supplier: "", status: "unmapped" };

const Stat = ({ label, value }) => (
  <div className="text-base" style={{ color: "#3c4450" }}>
    {label}
    <b className="ml-2" style={{ fontSize: 19 }}>
      {value}
    </b>
  </div>
);

const StatDivider = () => (
  <div style={{ width: 1, height: 26, background: "#e5e8ec" }} />
);

const BrandMappings = ({ tabId, setTabId }) => {
  const [queue, setQueue] = React.useState(() =>
    MOCK_QUEUE.map((item) => ({
      ...item,
      mode: "brand",
      target: item.suggestion || undefined,
      expanded: false,
      checked: {},
    }))
  );
  const [brands, setBrands] = React.useState(MOCK_BRANDS);
  const [brandSearch, setBrandSearch] = React.useState("");
  const [filters, setFilters] = React.useState(EMPTY_FILTERS);
  const [appliedFilters, setAppliedFilters] = React.useState(EMPTY_FILTERS);

  const updateRow = (id, patch) =>
    setQueue((prev) =>
      prev.map((item) => (item.id === id ? { ...item, ...patch } : item))
    );

  const selectedSkus = (item) =>
    item.products.filter((product) => item.checked[product.sku]);

  const isReady = (item) =>
    !!item.target && (item.mode === "brand" || selectedSkus(item).length > 0);

  const mapRow = (item) => {
    const brand = brands.find((b) => b.code === item.target);
    if (!brand || !isReady(item)) return;

    const count =
      item.mode === "brand" ? item.products.length : selectedSkus(item).length;

    setQueue((prev) =>
      item.mode === "brand"
        ? prev.filter((row) => row.id !== item.id)
        : prev
            .map((row) =>
              row.id === item.id
                ? {
                    ...row,
                    products: row.products.filter((p) => !row.checked[p.sku]),
                    checked: {},
                  }
                : row
            )
            .filter((row) => row.products.length)
    );

    setBrands((prev) =>
      prev.map((b) =>
        b.code === brand.code
          ? {
              ...b,
              products: b.products + count,
              aliases:
                item.mode === "brand" && !b.aliases.includes(item.incoming)
                  ? [...b.aliases, item.incoming]
                  : b.aliases,
            }
          : b
      )
    );

    antdAsyncMessageSuccess({
      key: "brand_mapping",
      text: `${count} product(s) mapped to ${brand.name}`,
    });
  };

  const ignoreRow = (item) =>
    setQueue((prev) => prev.filter((row) => row.id !== item.id));

  const visibleQueue = queue.filter((item) => {
    const { incoming, sku, supplier, status } = appliedFilters;
    if (status === "mapped") return false;
    if (supplier && item.supplier !== supplier) return false;
    if (incoming && !item.incoming.toLowerCase().includes(incoming.toLowerCase()))
      return false;
    if (
      sku &&
      !item.products.some((p) => p.sku.toLowerCase().includes(sku.toLowerCase()))
    )
      return false;
    return true;
  });

  const term = brandSearch.trim().toLowerCase();
  const visibleBrands = brands.filter(
    (b) => !term || b.name.toLowerCase().includes(term) || b.code.includes(term)
  );

  const brandOptions = brands.map((b) => ({
    label: `${b.name} · ${b.code}`,
    value: b.code,
  }));

  const scopeHint = (item) => {
    if (item.mode === "brand") {
      return `Applies to all ${item.products.length} products and every future product arriving under this name.`;
    }
    const selected = selectedSkus(item).length;
    return selected
      ? `${selected} of ${item.products.length} SKUs selected.`
      : "Select the SKUs to move. The rest stay in the queue.";
  };

  const setFilter = (key, value) =>
    setFilters((prev) => ({ ...prev, [key]: value }));

  return (
    <>
      <ContentBlock>
        <div
          className="d-flex align-items-center flex-wrap px-4"
          style={{ gap: 26 }}
        >
          <Stat label="Unmapped brand names" value={queue.length} />
          <StatDivider />
          <Stat
            label="Products awaiting mapping"
            value={queue.reduce((n, item) => n + item.products.length, 0)}
          />
          <StatDivider />
          <Stat label="Brands in database" value={brands.length} />
        </div>
      </ContentBlock>

      <div className="col-12">
        <TabUi tabId={tabId} setTabId={setTabId} />
      </div>

      <ContentBlock containerClass={"py-1"}>
        <TableFilterBox
          filter={true}
          onFilter={() => setAppliedFilters(filters)}
          add={false}
          clearFilter={() => {
            setFilters(EMPTY_FILTERS);
            setAppliedFilters(EMPTY_FILTERS);
          }}
        >
          <div className="d-flex flex-wrap">
            <div className="px-1">
              <TextInput
                text="Incoming brand name"
                name="incoming"
                style={{ width: 220 }}
                value={filters.incoming}
                onChange={(event) => setFilter("incoming", event.target.value)}
              />
            </div>
            <div className="px-1">
              <TextInput
                text="SKU"
                name="sku"
                style={{ width: 180 }}
                value={filters.sku}
                onChange={(event) => setFilter("sku", event.target.value)}
              />
            </div>
            <div className="px-1">
              <SelectInput
                label="Supplier"
                name="supplier"
                style={{ width: 180 }}
                value={filters.supplier}
                options={SUPPLIER_OPTIONS}
                onChange={(value) => setFilter("supplier", value)}
              />
            </div>
            <div className="px-1">
              <SelectInput
                label="Status"
                name="status"
                style={{ width: 180 }}
                value={filters.status}
                options={STATUS_OPTIONS}
                onChange={(value) => setFilter("status", value)}
              />
            </div>
          </div>
        </TableFilterBox>

        <div
          className="px-3 py-2 text-muted"
          style={{ background: "#f7f9fb", borderTop: "1px solid #eef0f3" }}
        >
          <small>
            Map the whole incoming brand name at once, or pick individual SKUs
            when a supplier feed mixes several real brands under one name.
          </small>
        </div>

        <div className="table-responsive">
          <table className="table mt-3">
            <thead>
              <tr className="text-muted">
                <th className="text-black" style={{ width: 210 }}>Incoming brand</th>
                <th className="text-black">Products / SKU</th>
                <th className="text-black" style={{ width: 140 }}>Supplier</th>
                <th className="text-black" style={{ width: 320 }}>Map to brand</th>
                <th className="text-black" style={{ width: 130 }}></th>
              </tr>
            </thead>
            <tbody>
              {visibleQueue.map((item) => {
                const shown = item.expanded
                  ? item.products
                  : item.products.slice(0, VISIBLE_SKUS);
                const ready = isReady(item);

                return (
                  <tr className="tableColumn" key={item.id}>
                    <td>
                      <div className="font-weight-bold">{item.incoming}</div>
                      <div className="text-muted mt-1">
                        <small>{item.products.length} products waiting</small>
                      </div>
                    </td>
                    <td>
                      {shown.map((product) => (
                        <div
                          key={product.sku}
                          className="d-flex align-items-baseline py-1"
                          style={{ gap: 10 }}
                        >
                          {item.mode === "sku" && (
                            <Checkbox
                              checked={!!item.checked[product.sku]}
                              onChange={() =>
                                updateRow(item.id, {
                                  checked: {
                                    ...item.checked,
                                    [product.sku]: !item.checked[product.sku],
                                  },
                                })
                              }
                            />
                          )}
                          <span
                            className="text-muted"
                            style={{
                              fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                              fontSize: 13,
                              minWidth: 96,
                            }}
                          >
                            {product.sku}
                          </span>
                          <span>{product.name}</span>
                        </div>
                      ))}
                      {item.products.length > VISIBLE_SKUS && (
                        <span
                          className="text-primary d-inline-block mt-1"
                          role="button"
                          onClick={() =>
                            updateRow(item.id, { expanded: !item.expanded })
                          }
                        >
                          {item.expanded
                            ? "Show less"
                            : `Show all ${item.products.length}`}
                        </span>
                      )}
                    </td>
                    <td>{item.supplier}</td>
                    <td>
                      <Segmented
                        className="mb-2"
                        value={item.mode}
                        options={[
                          { label: "Whole brand", value: "brand" },
                          { label: "Selected SKUs", value: "sku" },
                        ]}
                        onChange={(mode) =>
                          updateRow(
                            item.id,
                            mode === "sku" ? { mode, expanded: true } : { mode }
                          )
                        }
                      />
                      <Select
                        showSearch
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Choose brand…"
                        optionFilterProp="label"
                        value={item.target}
                        options={brandOptions}
                        onChange={(target) => updateRow(item.id, { target })}
                      />
                      <div className="text-muted mt-1">
                        <small>{scopeHint(item)}</small>
                      </div>
                    </td>
                    <td>
                      <div
                        className="d-flex justify-content-end"
                        style={{ gap: 8 }}
                      >
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          disabled={!ready}
                          onClick={() => mapRow(item)}
                        >
                          Map
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          title="Ignore"
                          onClick={() => ignoreRow(item)}
                        >
                          ✕
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {visibleQueue.length === 0 && (
            <div className="text-center text-muted py-5">
              Nothing left in the mapping queue.
            </div>
          )}
        </div>
      </ContentBlock>

      <ContentBlock containerClass={"py-1"} extraClass="mt-3">
        <div className="d-flex align-items-center justify-content-between px-3 py-3">
          <h5 className="m-0 font-weight-bold">Brands</h5>
          <div style={{ width: 240 }}>
            <TextInput
              name="brand_search"
              placeholder="Filter brands"
              value={brandSearch}
              onChange={(event) => setBrandSearch(event.target.value)}
            />
          </div>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr className="text-muted">
                <th className="text-black" style={{ width: 200 }}>Brand</th>
                <th className="text-black" style={{ width: 190 }}>Brand code</th>
                <th className="text-black">Mapped incoming names</th>
                <th className="text-black" style={{ width: 120 }}>Products</th>
                <th className="text-black" style={{ width: 110 }}></th>
              </tr>
            </thead>
            <tbody>
              {visibleBrands.map((brand) => (
                <tr className="tableColumn" key={brand.code}>
                  <td className="font-weight-bold">{brand.name}</td>
                  <td
                    className="text-muted"
                    style={{
                      fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                      fontSize: 13,
                    }}
                  >
                    {brand.code}
                  </td>
                  <td>
                    <div className="d-flex flex-wrap" style={{ gap: 6 }}>
                      {brand.aliases.length ? (
                        brand.aliases.map((alias) => (
                          <span
                            key={alias}
                            style={{
                              background: "#eef7fc",
                              color: "#12628a",
                              borderRadius: 4,
                              padding: "4px 9px",
                              fontSize: 13,
                            }}
                          >
                            {alias}
                          </span>
                        ))
                      ) : (
                        <span className="text-muted">—</span>
                      )}
                    </div>
                  </td>
                  <td>{brand.products.toLocaleString("lt-LT")}</td>
                  <td className="text-right">
                    <span className="text-primary" role="button">
                      View
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ContentBlock>
    </>
  );
};

export default BrandMappings;
